module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURSUsOCguOiIuOEdwTCYuOSguOioqPiktORF/rDkAAAAIdFJOU3N+FgBjRgwhQbh47wAAALRJREFUKM9lkk0Kg0AMhaP1ABMY6bbgBYpW3VZKcV0svYD0AMXen+ZntMLLYnj5SDKZZKhR65/XeF9Mkh7vjMXCawWt+UImB93AyeJs4MSb5Qq67A/CLODCO7sJeOxB2ZBmjH7tV3OoFblY3byXY6KzylpCQqX4QB9O2igfyWqK4wFckrUpngdwdCAhHiDA+wxVnQQCSIGicC00Bq3D4+D5MCAcIQwZ1oCLglXisvU7DEX6Dj/XozsKPs4xHAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_icon_01_zh.png
// module id = vKfK
// module chunks = 34